export default function formatDate(dateString) {
  const date = new Date(dateString);
  if (date === undefined) return dateString;
  else {
    return date.toLocaleTimeString() + ' ' + date.toLocaleDateString();
  }
}